<div>
    <p-table [value]="despesas" [lazy]="true" (onLazyLoad)="loadDespesas($event)" [paginator]="true" [rows]="100" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [rowsPerPageOptions]="[20, 50, 100]" [totalRecords]="totalRecords" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"  [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true" [tableStyle]="{'font-size':'.9rem', 'font-weight':'400', 'border-spacing':'0 0 !important', 'border-colapse': 'separate'}"  #dt>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="cdEmpresaErp">Empresa ERP <p-sortIcon field="cdEmpresaErp"></p-sortIcon></th>
            <th pSortableColumn="cdFilialErp">Filial ERP <p-sortIcon field="cdFilialErp"></p-sortIcon></th>
            <th pSortableColumn="dtRefer">Data Referência <p-sortIcon field="dtRefer"></p-sortIcon></th>
            <th pSortableColumn="cdCcustoErp">Centro de Custo ERP <p-sortIcon field="cdCcustoErp"></p-sortIcon></th>
            <th pSortableColumn="cdContaErp">Conta ERP <p-sortIcon field="cdContaErp"></p-sortIcon></th>
            <th pSortableColumn="vlMovim">Valor Movimento <p-sortIcon field="vlMovim"></p-sortIcon></th>
            <th pSortableColumn="instancia">Instância <p-sortIcon field="instancia"></p-sortIcon></th>
            <th pSortableColumn="cdEmpresaPims">Empresa PIMS <p-sortIcon field="cdEmpresaPims"></p-sortIcon></th>
            <th pSortableColumn="dtUltatu">Data Última Atualização <p-sortIcon field="dtUltatu"></p-sortIcon></th>
            <th pSortableColumn="dtRecebido">Data Recebido <p-sortIcon field="dtRecebido"></p-sortIcon></th>
            <th pSortableColumn="fgStatusInteg">Status Integração <p-sortIcon field="fgStatusInteg"></p-sortIcon></th>
            <th pSortableColumn="dtIntegPims">Data Integração PIMS <p-sortIcon field="dtIntegPims"></p-sortIcon></th>
            <th pSortableColumn="deMensagemInteg">Mensagem Integração <p-sortIcon field="deMensagemInteg"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-despesa>
          <tr>
            <td>{{ despesa.cdEmpresaErp }}</td>
            <td>{{ despesa.cdFilialErp }}</td>
            <td>{{ despesa.dtRefer | date: 'dd/MM/yyyy' }}</td>
            <td>{{ despesa.cdCcustoErp }}</td>
            <td>{{ despesa.cdContaErp }}</td>
            <td>{{ despesa.vlMovim.toLocaleString("pt-BR") }}</td>
            <td>{{ despesa.instancia }}</td>
            <td>{{ despesa.cdEmpresaPims }}</td>
            <td>{{ despesa.dtUltatu | date: 'dd/MM/yyyy' }}</td>
            <td>{{ despesa.dtRecebido | date: 'dd/MM/yyyy' }}</td>
            <td><app-tag-status [status]="despesa.fgStatusInteg"></app-tag-status></td>
            <td>{{ despesa.dtIntegPims | date: 'dd/MM/yyyy' }}</td>
            <td>{{ despesa.deMensagemInteg }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <td colspan="21">Nenhum registro encontrado</td>
      </ng-template>
      </p-table>
</div>